<app-navbar></app-navbar>
servicios
<app-sidenav>
    works
</app-sidenav>